module.exports = __webpack_public_path__ + "ve.93b2af8f0b90b8099d4a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ve.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ve.svg
// module chunks = styles